import * as React from 'react';

import styles from './styles.module.scss';

export const FieldAvatar = ({ ...other }) => (
  <div className={styles.field_avatar} {...other} />
);

export default FieldAvatar;
